module.exports = "/_next/static/images/home_iphoneX-05a0bfc30b66f990e8c069074fbc1078.png";